import { Injectable } from '@angular/core';
import { Http, Headers, BaseRequestOptions, RequestOptions, RequestMethod, Jsonp, URLSearchParams } from '@angular/http';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise'
import { Subject } from 'rxjs/Subject'
//Providers
import { ConfigProvider } from '../providers/config-provider';

//Models
import { Url } from '../models/url.model';
import { Agenda } from '../models/agenda.model';

@Injectable()
export class AgendaProvider {
    private result;
    public headers: Headers;
    public options: RequestOptions;
    public urlCongresso = new Url;
    public params = new URLSearchParams();

    constructor(public http: Http,
                private jsonp: Jsonp,
                public configProvider: ConfigProvider) {
        this.urlCongresso = configProvider.url;
        this.headers = new Headers({ 'Content-Type': 'application/json', 'Authorization': this.urlCongresso.SgunAuthorization, 'MobileReferer': this.urlCongresso.SgunReferer });
        this.options = new RequestOptions({ headers: this.headers });

        this.params.set('format', 'json');
        this.params.set('callback', this.configProvider.CALLBACK);
    }

    getAtividadesInscritasUsuario(guidUsuario, congressoAno):Promise<Array<Agenda>> {
        this.params.set('usuarioGuid', guidUsuario);
        this.params.set('eventoAno', congressoAno);
        return this.jsonp.get(this.urlCongresso.Cientifico + '/shared/apc/getInscricoesUsuario.ashx', {search: this.params })
                .map(res => res.json() as Agenda[]).toPromise()
   }

}


// WEBPACK FOOTER //
// ./src/providers/agenda-provider.ts